import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import BigCalendar from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';

import moment from 'moment';

const localizer = BigCalendar.momentLocalizer(moment);

const DragAndDropCalendar = withDragAndDrop(BigCalendar);

export default class CalendarComponent extends PureComponent {
  static propTypes = {
    events: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      allDay: PropTypes.bool,
      start: PropTypes.instanceOf(Date),
      end: PropTypes.instanceOf(Date),
      priority: PropTypes.string,
    })).isRequired,
    nav: PropTypes.func,
    select: PropTypes.func,
    small: PropTypes.bool,
  };

  static defaultProps = {
    small: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      events: this.props.events,
    };
  }

  moveEvent = ({ event, start, end }) => {
    const { events } = this.state;

    const idx = events.indexOf(event);
    const updatedEvent = { ...event, start, end };

    const nextEvents = [...events];
    nextEvents.splice(idx, 1, updatedEvent);

    this.setState({
      events: nextEvents,
    });
  };

  eventStyleGetter = (event) => {
    let color;

    switch (event.priority) {
      case 'high':
        color = '#fa697d';
        break;

      case 'family':
        color = '#4ce1b6';
        break;

      case 'non':
        color = '#70bbfd';
        break;

      case 'red':
        color = '#e74c3c';
        break;

      case 'green':
        color = '#1abc9c';
        break;

      case 'blue':
        color = '#3498db';
        break;

      case 'purple':
        color = '#9b59b6';
        break;

      case 'grey':
        color = '#34495e';
        break;

      case 'yellow':
        color = '#f1c40f';
        break;

      case 'orange':
        color = '#e67e22';
        break;

      default:
        color = '$color-additional';
        break;
    }

    const style = {
      backgroundColor: color,
      border: 'none',
    };

    return {
      style,
    };
  };

  render() {
    const { small, events, nav, select } = this.props;

    return (
      <div className={`calendar${small ? ' calendar--small' : ''}`}>
        <DragAndDropCalendar
          events={events}
          views={['month', 'week', 'day']}
          popup
          step={60}
          timeslots={1}
          showMultiDayTimes
          localizer={localizer}
          onEventDrop={this.moveEvent}
          defaultDate={new Date()}
          eventPropGetter={(this.eventStyleGetter)}
          onNavigate={nav}
          onSelectEvent={select}
          messages={{
            previous: <span className="lnr lnr-chevron-left" />,
            next: <span className="lnr lnr-chevron-right" />,
            today: <span className="lnr lnr-calendar-full" />,
          }}
        />
      </div>
    );
  }
}
